import { render, staticRenderFns } from "./SaleBook.vue?vue&type=template&id=5174aae4"
import script from "./SaleBook.vue?vue&type=script&lang=js"
export * from "./SaleBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports